"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_shopping__trolley__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "a2842e71-4b8f-4a63-b160-bf1b5f1e1aec",
    "data-name": "Shopping_trolley_ic_hi",
    viewBox: "0 0 191.5 191.5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "359827cf-4076-4e66-ac0c-544c254b733c",
    "data-name": "Bounding Box",
    points: "0 191.5 0 0 191.5 0 191.5 191.5 0 191.5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.67,111.67H67.75l-20-72H164.22a8,8,0,0,1,7.71,10.14l-15.56,56A8,8,0,0,1,148.67,111.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.77,100.34,87.7,52.73a4,4,0,0,1,3.46-4.47h0a4,4,0,0,1,4.47,3.46l6.07,47.61a4,4,0,0,1-3.46,4.47h0A4,4,0,0,1,93.77,100.34Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,100.8,66,54.28a4,4,0,0,1,2.89-4.86h0a4,4,0,0,1,4.86,2.89L85.62,98.83a4,4,0,0,1-2.89,4.86h0A4,4,0,0,1,77.87,100.8Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.87,100.34l6.07-47.61a4,4,0,0,0-3.46-4.47h0A4,4,0,0,0,132,51.71l-6.07,47.61a4,4,0,0,0,3.46,4.47h0A4,4,0,0,0,133.87,100.34Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.77,100.8l11.84-46.52a4,4,0,0,0-2.89-4.86h0a4,4,0,0,0-4.86,2.89L142,98.83a4,4,0,0,0,2.89,4.86h0A4,4,0,0,0,149.77,100.8Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.75,
    y: 47.81,
    width: 8,
    height: 56,
    rx: 4,
    ry: 4,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.93,47.81l-15.56,56a8,8,0,0,1-7.71,5.86H67.75l-19.44-70h-.56l20,72h80.92a8,8,0,0,0,7.71-5.86l15.56-56a8,8,0,0,0,.22-3.14A8.12,8.12,0,0,1,171.93,47.81Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.71,99.33,95.63,51.71a4,4,0,1,0-7.94,1l.08.63a4,4,0,0,1,7.86.36l6,47A3.93,3.93,0,0,0,101.71,99.33Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.62,98.83,73.78,52.31a4,4,0,0,0-7.75,2v.06a4,4,0,0,1,7.74,0l11.83,46.46A3.94,3.94,0,0,0,85.62,98.83Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.48,48.25A4,4,0,0,0,132,51.71l-6.07,47.61a3.93,3.93,0,0,0,.08,1.37l6-47a4,4,0,0,1,7.86-.36l.08-.63A4,4,0,0,0,136.48,48.25Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.73,51.42a4,4,0,0,1,2.88,2.92v-.06a4,4,0,1,0-7.75-2L142,98.83a3.94,3.94,0,0,0,0,1.94l11.83-46.46A4,4,0,0,1,158.73,51.42Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.75,47.81a4,4,0,0,0-4,4v2a4,4,0,0,1,8,0v-2A4,4,0,0,0,113.75,47.81Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.83,127.67H77.3l-28-98.11a8,8,0,0,0-7.69-5.8H19.86a4.12,4.12,0,0,0-4.15,3.61,4,4,0,0,0,4,4.39H41.6l27.72,97.08-4.54,16.9L72.46,148l3.3-12.29h72.07a4,4,0,0,0,0-8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.83,127.67H77.3l-28-98.11a8,8,0,0,0-7.69-5.8H19.86a4.12,4.12,0,0,0-4.15,3.61,4,4,0,0,0,4,4.39H41.6l27.72,97.08-4.54,16.9L72.46,148l3.3-12.29h72.07a4,4,0,0,0,0-8Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.86,23.75a4.12,4.12,0,0,0-4.15,3.61,4,4,0,0,0,4,4.39H41.42v-8Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,29.75H19.69a4,4,0,0,1-3.86-3,3.77,3.77,0,0,0-.12.63,4,4,0,0,0,4,4.39H41.6L69,127.86l.28-1Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.83,133.67H75.76L72.46,146l-7.19-2.08-.5,1.86L72.46,148l3.3-12.29h72.07a4,4,0,0,0,3.86-5A4,4,0,0,1,147.83,133.67Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.83,26.73a3.77,3.77,0,0,0-.12.63,4,4,0,0,0,4,4.39H41.42v-2H19.69A4,4,0,0,1,15.83,26.73Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.8,
    cy: 143.79,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.97,
    cy: 143.79,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,149.79a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,139.8,149.79Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,149.79a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,68,149.79Z",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "shopping-trolley-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "b5c8e1e6-4b2e-4757-a000-13f479973bf5",
    "data-name": "Shopping_trolley_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "c737613e-7d0d-4868-8fb0-4d457472f1c0",
    "data-name": "Shopping_trolley_ic_hi",
    width: 191.5,
    height: 191.5,
    transform: "translate(0.25 0.25)",
    xlinkHref: "#a2842e71-4b8f-4a63-b160-bf1b5f1e1aec"
  })));
}

var _default = ic_shopping__trolley__dark;
exports.default = _default;